import React, { Suspense, lazy } from 'react'
import { LoadingLogo } from '@/components/atoms/LoadingLogo/LoadingLogo'
import PageWrapper from '@/components/organisms/PageWrapper/PageWrapper'

// Carga los componentes de manera dinámica y especifica la importación de 'default'
const Header = lazy(
  async () =>
    await import('@/components/organisms/Header/Header').then((module) => ({
      default: module.default
    }))
)
const BannerHome = lazy(
  async () =>
    await import('@/components/templates/BannerHome/BannerHome').then((module) => ({
      default: module.default
    }))
)
const FormTransactionsExport = lazy(
  async () =>
    await import('@/components/templates/FormTransactionsExport/FormTransactionsExport').then(
      (module) => ({ default: module.default })
    )
)
const PricesCarrusel = lazy(
  async () =>
    await import('@/components/templates/PricesCarrusel/PricesCarrusel').then((module) => ({
      default: module.default
    }))
)
const OurVision = lazy(
  async () =>
    await import('@/components/templates/OurVision/OurVision').then((module) => ({
      default: module.default
    }))
)
const WhyChoose = lazy(
  async () =>
    await import('@/components/templates/WhyChoose/WhyChoose').then((module) => ({
      default: module.default
    }))
)
const BannerYourSecurity = lazy(
  async () =>
    await import('@/components/templates/BannerYourSecurity/BannerYourSecurity').then((module) => ({
      default: module.default
    }))
)
const AreYouLooking = lazy(
  async () =>
    await import('@/components/templates/AreYouLooking/AreYouLooking').then((module) => ({
      default: module.default
    }))
)
const WhatWeYourCompany = lazy(
  async () =>
    await import('@/components/templates/WhatWeYourCompany/WhatWeYourCompany').then((module) => ({
      default: module.default
    }))
)
const FormContactUs = lazy(
  async () =>
    await import('@/components/templates/FormContactUs/FormContactUs').then((module) => ({
      default: module.default
    }))
)
const FrequentlyAskedQuestions = lazy(
  async () =>
    await import('@/components/templates/FrequentlyAskedQuestions/FrequentlyAskedQuestions').then(
      (module) => ({ default: module.default })
    )
)
const Footer = lazy(
  async () =>
    await import('@/components/organisms/Footer/Footer').then((module) => ({
      default: module.default
    }))
)

export const Home: React.FC = () => {
  const buildDate = new Date().toISOString()

  return (
    <PageWrapper
      title="Basciano Hong Kong | International business payments"
      description="Basciano Hong Kong offers secure and innovative solutions for payments the management of business payments, risk management and corporate trade finance. Streamline your business with our expertise."
      url="https://www.basciano.com"
      keywords={[
        'Basciano Hong Kong',
        'BTC TRADING CORPORATION',
        'Trade finance solutions',
        'Trading Corporation',
        'International Financial transactions',
        'Secure International payments',
        'Financial risk management',
        'Specialized financing',
        'Innovative financial services',
        'Global business solutions',
        'International supplier payments',
        'Secure and innovative financial solutions for businesses in Hong Kong.',
        'Optimise your international payments with Basciano Hong Kong',
        'Mitigate financial risks and expand globally',
        'Tailor-made trade finance solutions for Hong Kong companies',
        'Secure, efficient and innovative: Basciano Hong Kong'
      ]}
      language="en"
      publishedTime={buildDate}
    >
      <Suspense fallback={<LoadingLogo />}>
        <div className="min-h-screen flex flex-col overflow-hidden">
          <Header />
          <main className="flex-grow">
            <section id="home">
              <BannerHome />
            </section>
            <section id="formTransactionsExport">
              <FormTransactionsExport />
            </section>
            <section id="pricesCarrusel">
              <PricesCarrusel />
            </section>
            <section id="aboutUs">
              <OurVision />
            </section>
            <section id="whyChoose">
              <WhyChoose />
            </section>
            <section id="bannerYourSecurity">
              <BannerYourSecurity />
            </section>
            <section id="services">
              <AreYouLooking />
            </section>
            <section id="whatWeYourCompany">
              <WhatWeYourCompany />
            </section>
            <section id="formContactUs">
              <FormContactUs />
            </section>
            <section id="frequentlyAskedQuestions">
              <FrequentlyAskedQuestions />
            </section>
          </main>
          <Footer />
        </div>
      </Suspense>
    </PageWrapper>
  )
}
